import React from "react"
import { getAvailableOptions } from "@/components/ProductDetail/v3/SuperSkuOption/utils"
import SuperSkuOptionButton from "@/components/ProductDetail/v3/SuperSkuOption/SuperSkuOptionButton"
import styles from "@/components/ProductDetail/v3/SuperSkuOption/index.module.scss"

const SuperSkuOptionSetButtons = props => {
  const {
    field = "",
    value = "",
    onClick = () => {},
    availableOptions,
    variantOptions = [],
  } = props

  return (
    <div className={styles.superSkuOptionSet}>
      {variantOptions.map(option => {
        const { sku_s: sku = "", slug_s: slug = "" } = option
        const optionLabel =
          Array.isArray(option[field]) && option[field].length > 0
            ? option[field][0]
            : option[field] || ""
        const isActive = value === optionLabel
        const disabled = getAvailableOptions({
          availableOptions,
          option: optionLabel,
          field,
        })

        return (
          <SuperSkuOptionButton
            key={optionLabel}
            optionLabel={optionLabel}
            isActive={isActive}
            onClick={onClick}
            disabled={disabled}
            sku={sku}
            slug={slug}
          />
        )
      })}
    </div>
  )
}

export default SuperSkuOptionSetButtons
